import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";

export default function DgiSection({ S, data }) {
  return (
    <View style={[S.box, { marginTop: 10 }]}>
      <Text style={S.label}>Validación DGI</Text>

      <View style={{ flexDirection: "row", marginTop: 6 }}>

        {/* LADO IZQUIERDO */}
        <View style={{ flex: 1, paddingRight: 12 }}>
          <Text style={S.muted}>
            Consulte por la clave de acceso en:
          </Text>

          <Text
            style={{
              fontSize: 8,
              marginTop: 4,
              wordBreak: "break-all",
            }}
          >
            {data.consultaClaveUrl}
          </Text>

          <View style={{ marginTop: 6 }}>
            <Text style={S.bold}>CUFE:</Text>
            <Text>{data.cufe}</Text>
          </View>
        </View>

        {/* QR A LA DERECHA */}
        <View style={{ width: 100, alignItems: "flex-end" }}>


          <Image

            style={S.imageQr}

            src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=123456" />
        </View>

      </View>
    </View>
  );
}